import React, { useEffect, useState } from 'react'
import Layout from '../components/Layout/Layout';
import {getDoc, doc} from 'firebase/firestore';
import {db} from '../firebase.config';
import {getAuth} from 'firebase/auth';
import {useNavigate, Link, useParams} from 'react-router-dom';
import Spinner from '../components/Spinner';
import SwiperCore,{EffectCoverflow, Navigation, Pagination} from 'swiper'
import {Swiper, SwiperSlide} from 'swiper/react'
import 'swiper/swiper-bundle.css';
import 'swiper/swiper.min.css';
import {FaArrowAltCircleRight} from 'react-icons/fa'

SwiperCore.use([EffectCoverflow, Pagination ])

const Listing = () => {
    const [listing,setListing] = useState(null)
    const [loading, setLoading] = useState(true);
    const [price, setPrice] = useState("");
    const [defPrice, setDefPrice] = useState('');
    const [time, setTime] = useState(5);
    const navigate = useNavigate();
    const params = useParams();
    const auth = getAuth();

    useEffect(() => {
        const fetchListing = async() =>{
            const docRef = doc(db, 'listing', params.listingId)
            const docSnap = await getDoc(docRef)
            if(docSnap.exists()){
                console.log(docSnap.data())
                setListing(docSnap.data())
                setLoading(false)
                console.log(docSnap.data().userRef)

            if(docSnap.data().offer){
                setPrice(docSnap.data().offerPrice)
                setDefPrice(docSnap.data().offerPrice)
            }else{
                setPrice(docSnap.data().regularPrice)
                setDefPrice(docSnap.data().regularPrice)
            }
            }
            
            }

        fetchListing();
    }, [params.listingId]);

    const inctime =((e)=>{
        let tmpPrice = (defPrice/5);
        setTime(e.target.value);
        tmpPrice *= e.target.value;
        if(e.target.value>5) tmpPrice*=0.9;
        setPrice(tmpPrice)
    })

    if(loading){
        return <Spinner/>
    }

  return (
    <Layout>
        <div className='container d-flex align-items-center justify-content-center mt-4'>
            <div className='card shadow listtt' style={{width:'53%'}}>
                <div className='card-header'>
                    {listing.imgUrls === undefined ? (<Spinner/>) : (
                        <Swiper 
                        effect={'coverflow'}
                        centeredSlides={true}
                        slidesPerView={1}
                        coverflowEffect={{
                            rotate:50,
                            stretch:0,
                            depth:100,
                            modifier:1,
                            slideShadows:true
                        }}
                        pagination={true}
                        className='myswipe'
                        >
                            {listing.imgUrls.map((url, index)=>(
                                <SwiperSlide key={index} className='slidesize'>
                                    <img src={listing?.imgUrls[index]} 
                                    alt ={listing?.name} />
                                </SwiperSlide>

                            ))} 
                        </Swiper>
                    ) }
                </div>
                <div className='card-body'>
                    <h3 className='text-center'>{listing.name}</h3>
                    <h6><p>Price : Rs. {price}/- {listing.type==="lease" && `For ${time} Years`}</p></h6>
                    {listing.type==="lease" &&
                    <p>Need For :&nbsp;
                    <select className='p-1 dopper' onChange={inctime}>
                    <option value="5">5 Years</option>
                    <option value="10">10 Years</option>
                    <option value="25">25 Years</option>
                    <option value="50">50 Years</option>
                    </select>
                    </p>
                    }
                    <p>Property For : {listing.type === "rent" ? "Rent" : listing.type==="sale" ? "Sale" : "Lease" }</p>
                    <p>{listing.offer && (
                        <span>
                            Rs. {listing.regularPrice - listing.offerPrice} Discount
                        </span>
                    ) } </p>
                    <p>{listing.bedrooms >1 ? `${listing.bedrooms} Bedrooms` : '1 Bedroom' }</p>
                    <p>{listing.parking ? `Parking Spot` : 'No Spot for Parking' }</p>
                    <p>{listing.furnished ? `Furnished House` : 'Not Furnished' }</p>
                    <Link className='btn btn-success' to={`/contact/${listing.userRef}?listingName=${listing.name}`}>Contact Landlord <FaArrowAltCircleRight/> </Link>
                    
                    {listing.type === "lease" && (
                        <p className='lower mt-3 mb-0 d-flex justify-content-end'>** You get a Discounted Price as you Increase the Time !</p>
                    )}
                    </div>
            </div>
        </div>
    </Layout>
  )
}

export default Listing